import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface IProps {
  isAuth: boolean;
  isLoading?: boolean;
  redirectPath: string;
  children: ReactNode;
  data?: unknown;
}

const ProtectedRoute = ({ isAuth, isLoading = false, redirectPath, children, data }: IProps) => {
  if (isLoading) return null;
  if (!isAuth && /^https?:\/\//i.test(redirectPath)) {
    window.location.replace(redirectPath);
    return null;
  }
  if (!isAuth) return <Navigate to={redirectPath} replace state={data} />;
  return <>{children}</>;
};

export default ProtectedRoute;
